import { render } from "./DialogRemoveItem.vue?vue&type=template&id=9c1fbff6"
import script from "./DialogRemoveItem.vue?vue&type=script&lang=js"
export * from "./DialogRemoveItem.vue?vue&type=script&lang=js"

import "./DialogRemoveItem.vue?vue&type=style&index=0&id=9c1fbff6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__